module.exports = __webpack_public_path__ + "static/media/Group 10844.a7045d88.png";